module.exports = __webpack_public_path__ + "img/logoCom.03b807a5.svg";